import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ChartCard({ title, subtitle, linkTo, linkLabel = "Open", testId, children }) {
  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4" data-testid={testId}>
      <div className="flex items-start justify-between mb-2">
        <div>
          <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
          {subtitle && <p className="text-[11px] text-slate-400 mt-0.5">{subtitle}</p>}
        </div>
        {linkTo && (
          <Link to={linkTo} className="text-[11px] text-blue-600 hover:text-blue-700 inline-flex items-center gap-1 shrink-0" data-testid={`${testId}-link`}>
            {linkLabel} <ArrowRight className="h-3 w-3" />
          </Link>
        )}
      </div>
      <div className="h-56">{children}</div>
    </div>
  );
}
